import { SliderProps } from '@procore/core-react/dist/_typedoc/Slider/Slider.types.json';
import * as React from 'react';
export default {
  SliderProps,
  React
};